export const isDebugMode = () => {
  const params = new URLSearchParams(window?.location?.search);
  const key = '__DEBUGPIXELS__';
  return params.has(key);
};

export const log = (...args: any) => {
  /* tslint:disable */
  isDebugMode() && console.log(...args);
  /* tslint:enable */
};
